// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay--2_sbe8bXI1"};